import { render, staticRenderFns } from "./ComplaintVerification.vue?vue&type=template&id=f29e026e&scoped=true&"
import script from "./ComplaintVerification.vue?vue&type=script&lang=js&"
export * from "./ComplaintVerification.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintVerification.vue?vue&type=style&index=0&id=f29e026e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29e026e",
  null
  
)

export default component.exports